import { PaywallFeature } from 'frontend/types/premium';

export function getFeatureList(): PaywallFeature[] {
  const features = [
    { text: 'Synced progress across web and mobile apps', premium: false },
    {
      text: 'Guided courses',
      premium: true,
      subfeatures: [
        { text: 'Foundational math courses', premium: true },
        { text: 'Advanced math courses', premium: true },
        { text: 'Science courses', premium: true },
        { text: 'Computer science courses', premium: true },
      ],
    },
    { text: 'Bonus math, science, and CS puzzles', premium: true },
  ];
  return features;
}
